<template>
  <div class="popup-box">
    <!-- <div class="popup"> -->
    <div type="loginTipsDialogWrapper" class="popup">
      <a
        type="closeBtn"
        href="javascript:void(0);"
        class="close"
        @click="close"
      ></a>
      <h3 class="title">{{ title }}</h3>
      <p class="content">{{ content }}</p>
    </div>
    <div class="login-closeBg" @click="close"></div>
  </div>
</template>

<script type="text/javascript">
export default {
  methods: {
    close() {
      this.$emit('closePopup');
    }
  },
  props: ['title', 'content']
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/webLogin-v3.scss';

.popup-box {
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.popup {
  border-radius: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 11;
  background: #f3f3f3;
  width: 51.5vh;
  max-width: 90%;
  padding: 2.78vh;
  box-sizing: border-box;
}
.title {
  font-size: 2.41vh;
  margin: auto;
  padding-top: 2.31vh;
  box-sizing: border-box;
  color: #000;
  line-height: 100%;
}

.content {
  margin: 0 auto;
  font-size: 1.85vh;
  color: $font;
  line-height: 200%;
  width: 100%;
  padding: 11.1vh 2.78vh 15.82vh;
  box-sizing: border-box;
}

.close {
  background: url($imgV3Support + 'cancel.png') no-repeat top center;
  background-size: contain;
  width: 1.85vh;
  height: 1.85vh;
  position: absolute;
  top: 2.78vh;
  right: 2.78vh;
}

.login-closeBg {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
</style>
